import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "filterBtn", "modal"]

  connect() {
    this.activeCategory = "all"
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  filter(event) {
    const btn = event.currentTarget
    this.activeCategory = btn.dataset.category

    this.filterBtnTargets.forEach(b => {
      b.classList.toggle("feature-filter-btn--active", b === btn)
    })

    this.cardTargets.forEach(card => {
      const visible = this.activeCategory === "all" || card.dataset.category === this.activeCategory
      card.style.display = visible ? "" : "none"
    })

    this.closeModal()
  }

  openModal(event) {
    const link = event.currentTarget
    const url = new URL(link.href, window.location.origin)

    if (this.activeCategory && this.activeCategory !== "all") {
      url.searchParams.set("category", this.activeCategory)
    } else {
      url.searchParams.delete("category")
    }
    link.href = url.toString()

    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
  }

  closeModal() {
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
    const frame = this.modalTarget.querySelector("turbo-frame")
    if (frame) frame.innerHTML = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.closeModal()
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.closeModal()
  }
}
